var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { JsonToFormData } from 'shared/lib/JsonToFormData';
export var createCourse = createAsyncThunk('course/createCourse', function (data, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var extra, rejectWithValue, formData, updateResponse, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                extra = thunkAPI.extra, rejectWithValue = thunkAPI.rejectWithValue;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                data.lessons = {};
                data.groups = {};
                // @ts-ignore
                data.lesson_by_lesson = data.lesson_by_lesson ? 1 : 0;
                // @ts-ignore
                data.limited = data.limited ? 1 : 0;
                if (data.active_from) {
                    data.active_from = data.active_from.split('.').reverse().join('-') + ' 00:00:00';
                }
                if (data.active_to) {
                    data.active_to = data.active_to.split('.').reverse().join('-') + ' 00:00:00';
                }
                formData = new FormData();
                JsonToFormData(formData, data, 'Course');
                // formData.append('course_id', data!.course_id! as string)
                // @ts-ignore
                formData.append('Course[images][0]', data.images);
                return [4 /*yield*/, extra.api.post('/ext-course/frontend/manage/course/create', formData)];
            case 2:
                updateResponse = _a.sent();
                if (updateResponse.status !== 200 || updateResponse.data.status !== 200) {
                    throw new Error();
                }
                return [4 /*yield*/, extra.api.post('/ext-course/frontend/manage/course/get-course-by-id', { course_id: updateResponse.data.course_id })];
            case 3:
                response = _a.sent();
                if (!response.data) {
                    throw new Error();
                }
                if (response.data.course.active_from) {
                    response.data.course.active_from = response.data.course.active_from.split(' ')[0].split('-').reverse().join('.');
                }
                if (response.data.course.active_to) {
                    response.data.course.active_to = response.data.course.active_to.split(' ')[0].split('-').reverse().join('.');
                }
                return [2 /*return*/, response.data.course];
            case 4:
                e_1 = _a.sent();
                console.log(e_1);
                return [2 /*return*/, rejectWithValue('Не удалось получить курс по id')];
            case 5: return [2 /*return*/];
        }
    });
}); });
